module.exports = __webpack_public_path__ + "img/biciclettaWhite.623cf454.svg";